import React from "react";
import { cn } from "@/lib/utils";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        <h1 className="font-display text-[28px] font-extrabold text-[#10233f]">{title}</h1>
        {subtitle && <p className="mt-1 text-slate-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function Card({ className, children, ...rest }) {
  return <div className={cn("card-soft p-5", className)} {...rest}>{children}</div>;
}

export function SectionTitle({ icon: Icon, tint = "#1a5fd0", children, right }) {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2.5">
        {Icon && <span className="h-8 w-8 rounded-xl grid place-items-center" style={{ background: `${tint}18`, color: tint }}><Icon size={17} /></span>}
        <h3 className="font-display text-[18px] font-bold text-[#10233f]">{children}</h3>
      </div>
      {right}
    </div>
  );
}

export function StatusChip({ status }) {
  const map = {
    "On Track": ["#e6f7ec", "#2f9e57"], "On track": ["#e6f7ec", "#2f9e57"], "Completed": ["#e6f7ec", "#2f9e57"],
    "In Progress": ["#e8f1ff", "#1a5fd0"], "In progress": ["#fff3e0", "#e0842f"],
    "Not Started": ["#f1f4f9", "#7488a8"], "Active": ["#e6f7ec", "#2f9e57"],
    "Low Risk": ["#e6f7ec", "#2f9e57"], "Mild": ["#e8f1ff", "#1a5fd0"], "Moderate": ["#fff3e0", "#e0842f"], "Pending": ["#fff3e0", "#e0842f"],
  };
  const [bg, fg] = map[status] || ["#f1f4f9", "#7488a8"];
  return <span className="chip inline-flex items-center gap-1" style={{ background: bg, color: fg }}>{status}</span>;
}
